import { env } from '@shared/lib/env'

export const NOTION_IMAGE_PREFIX = 'data/notion/images'

/**
 * Images are only servable once the public bucket host is known — without it
 * {@link notionImageUrl} would emit `https://undefined.s3…`.
 */
export function isNotionImageHostConfigured() {
  return Boolean(env.NEXT_PUBLIC_BUCKET_NAME)
}

/**
 * Permanent, public URL for an image mirrored out of Notion by `mirrorImages`.
 * Kept apart from `notion.ts` so client components can build the URL without
 * pulling in the `server-only` Notion client.
 */
export function notionImageUrl(blockId: string) {
  return `https://${env.NEXT_PUBLIC_BUCKET_NAME}.s3.eu-central-1.amazonaws.com/${NOTION_IMAGE_PREFIX}/${blockId}`
}
